import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {Box, Stack, Typography} from 'views/components';

import LazyMarkdown from './LazyMarkdown';
import {formatTokens} from './chatUtils';

const metaSx = {fontSize: '10px', color: '#A8A49E', lineHeight: '100%'};

const ChatMessage = ({msg, scrollRoot}) => (
  <Box sx={{display: 'flex', flexDirection: 'column',
    alignItems: msg.role === 'user' ? 'flex-end' : 'flex-start'}}>
    {/* An answer stopped before any text has only the Stopped label. */}
    {!(msg.stopped && !msg.text) && (
      <Box
        sx={{
          maxWidth: '78%',
          px: '14px',
          py: '10px',
          borderRadius: msg.role === 'user' ? '14px 14px 4px 14px' : '14px 14px 14px 4px',
          backgroundColor: msg.role === 'user' ? '#DA7955' : '#F8F6F3',
          border: msg.role === 'assistant' ? '1px solid #E8E4DE' : 'none',
        }}
      >
        {msg.role === 'assistant' ? (
          <LazyMarkdown value={msg.text} root={scrollRoot} />
        ) : (
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              color: '#FFFFFF',
              lineHeight: '160%',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
          >
            {msg.text}
          </Typography>
        )}
      </Box>
    )}
    <Stack direction='row' sx={{gap: '6px', mt: '4px', px: '4px'}}>
      {msg.createdAt && moment(msg.createdAt).isValid() && (
        <Typography sx={metaSx}>
          {moment(msg.createdAt).format('MMM. D, YYYY HH:mm')}
        </Typography>
      )}
      {msg.role === 'assistant' && msg.usage && (
        <Typography sx={metaSx}>
          {formatTokens(msg.usage)}
        </Typography>
      )}
      {msg.stopped && (
        <Typography sx={{...metaSx, fontWeight: 600}}>
          Stopped
        </Typography>
      )}
    </Stack>
  </Box>
);

ChatMessage.propTypes = {
  msg: PropTypes.shape({
    role: PropTypes.oneOf(['user', 'assistant']).isRequired,
    text: PropTypes.string,
    createdAt: PropTypes.string,
    usage: PropTypes.object,
    stopped: PropTypes.bool,
  }).isRequired,
  scrollRoot: PropTypes.object,
};

// Memoized so streamed chunks and keystrokes do not re-parse the markdown of every earlier message.
export default React.memo(ChatMessage);
